import React, { useState, useContext } from "react";
import { AuthContext } from "../AuthContext";
import { Header, Subheader, HeaderContainer, L300, InputItem, T300Large, InputSection, Input, InputErrorText, PrimaryButton } from "./SharedStyles";
import TermsPrivacy from "./TermsPrivacy";
import { numOfHotels } from "../../../settings/IntegrationConstants";
import axios from "axios";
import { guestbookSites, environment } from "../../../settings/IntegrationConstants";
import WarningTriangle from "@/components/UI/Icons/WarningTriangle";
import I18n from "../../../translations/i18n";

type JoinScreenProps = {
  hotelName: string;
  onSuccess: () => void;
  onLoginClick: () => void;
  setUserData: (email: string) => void; 
};

const JoinScreen = ({ hotelName, onSuccess, onLoginClick, setUserData }: JoinScreenProps) => {
  const authContext: any = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState(false)

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(false)
    const submissionData = {
      account: {
        first_name: firstName,
        last_name: lastName,
        email: email,
        wid: window.gb_data.widget.identifier,
        source: 'be_modal_enrollment'
      },
    };
    axios
      .post(
        `${
          guestbookSites[environment as string].rewardsdash.url
        }/api/v1/accounts`,
        submissionData,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((response) => {
        if (response.status === 201) {
          localStorage.setItem("gb_storage_key", response.data.user_token);
          authContext.authenticate();
          onSuccess();
          setUserData(email)
        }
      })
      .catch((error) => {
        setError(true)
      });
  };

  return (
    <form onSubmit={onSubmit} style={{ width: "100%" }}>
      <HeaderContainer>
        <Header>
          {I18n.t(`views.hotel_integration.components.widget.mobile_modal.join.header`)}
        </Header>

        <Subheader>
          {I18n.t(`views.hotel_integration.components.widget.mobile_modal.join.subheader`, 
            {
              hotel_name: hotelName,
              num_of_hotels: numOfHotels
            }
          )}
        </Subheader>
      </HeaderContainer>

      <InputSection>
        <InputItem>
          <L300 color="strong">{I18n.t(`views.hotel_integration.components.widget.mobile_modal.join.email_address`)}</L300>
          <Input
            type="email"
            placeholder="example@email.com"
            value={email}
            onChange={(e) => setEmail(e.currentTarget.value)}
            required
            hasError={error}
          />
          {error && 
            <InputErrorText>
              <WarningTriangle/>
              {I18n.t(`views.hotel_integration.components.widget.mobile_modal.join.warning`)}
            </InputErrorText>
          }
        </InputItem>

        <InputItem>
          <L300 color="strong">{I18n.t(`views.hotel_integration.components.widget.mobile_modal.join.first_name`)}</L300>
          <Input
            type="text"
            placeholder={I18n.t(`views.hotel_integration.components.widget.mobile_modal.join.enter_first_name`)}
            value={firstName}
            onChange={(e) => setFirstName(e.currentTarget.value)}
            required
          />
        </InputItem>

        <InputItem>
          <L300 color="strong">{I18n.t(`views.hotel_integration.components.widget.mobile_modal.join.last_name`)}</L300>
          <Input
            type="text"
            placeholder={I18n.t(`views.hotel_integration.components.widget.mobile_modal.join.enter_last_name`)}
            value={lastName}
            onChange={(e) => setLastName(e.currentTarget.value)}
            required
          />
        </InputItem>
      </InputSection>
       
      <PrimaryButton type="submit">{I18n.t(`views.hotel_integration.components.widget.mobile_modal.buttons.join`)}</PrimaryButton>

      <T300Large>
        {I18n.t(`views.hotel_integration.components.widget.mobile_modal.join.already_member`)}{" "}
        <span onClick={onLoginClick}>{I18n.t(`views.hotel_integration.components.widget.mobile_modal.buttons.login`)}</span>
      </T300Large>

      <TermsPrivacy />
    </form>
  );
};

export default JoinScreen;
